.picker {
  display: inline-block;
}
.dialog {
  width: min-content;
}
.closed {
    border-width: 2px;
}
.open {
  display: grid;
  grid-template-columns: repeat(var(--number-of-columns), minmax(min-content, 1fr));
  gap: 2px;
  width: min-content;
  z-index: 2;

  > button {
    background-color: hsl(0, 0%, 85%);
    border-width: 1px;
    &:hover:not(.selected) {
      background-color: hsl(0, 0%, 75%);
    }
    &.selected {
      background-color: hsl(0, 0%, 65%);
      border-width: 2px;
    }
  }
}

